// export const HARPA_API = 'http://177.85.35.189:5002/api';
// export const HARPA_API_EMAILS = 'http://177.85.35.189:3030';

export const HARPA_API = 'https://ppc.b1legal.com:5443/api';
export const HARPA_API_EMAILS = 'https://ppc.b1legal.com:3030';
